import React, { useMemo } from 'react'
import { CartType } from '../../utils/Constants'
import './CartTypeInfo.css'

const CartTypeInfo =  ({ cartType }) => {
  return useMemo(() => {
    if (cartType === CartType.SINGEL_CART) {
      return <div className="cartTypeInfo flexColumn spaceAround">Singel</div>
    }
    else if (cartType === CartType.MULTI_CART) {
      return <div className="cartTypeInfo flexColumn spaceAround">Multivagn</div>
    }
    else {
      return null;
    }
  }, [cartType]);
}

export default CartTypeInfo